<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-layout row wrap class="pr-3 mb-2">
        <v-flex xs8 class="pb-0">
          <h3 class="darkblue--text fs-16 lh-16 font-weight-700">
            Backup Spending
          </h3>
          <v-breadcrumbs
            class="px-0 subtitle-2 mt-2 py-0 breadcrumbs-items custom-breadcrumbs"
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-flex>
      </v-layout>
    </v-container>

    <v-layout>
      <v-flex xs12>
        <v-card class="rounded-12 elevation-card pb-4">
          <v-card-title>
            <v-flex xs9 class="font-weight-500">
              Backup Spending
            </v-flex>
            <v-flex xs3 class="text-right">
              <v-icon class="mr-4"></v-icon>
              <v-icon id="refresh" @click="getData()">
                refresh
              </v-icon>
            </v-flex>
          </v-card-title>
          <v-data-table
            class="px-4 mt-1 nav-table"
            dense
            :items="items"
            :page.sync="page"
            @page-count="pageCount = $event"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50, 100]
            }"
          >
            <template v-slot:header>
              <thead>
                <tr style="width:100%">
                  <th>Backup Date</th>
                  <th>File Name</th>
                  <th width="20%">Action</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody v-if="items.length > 0">
                <tr v-for="(item, index) in items" :key="index">
                  <td>
                    {{ formatDateTime(item.backup_date) }}
                  </td>
                  <td>
                    {{ item.filename }}
                  </td>
                  <td class="text-center">
                    <v-btn
                      color="secondblue"
                      x-small
                      dark
                      @click="downloadBackup(item.id)"
                    >
                      Download
                    </v-btn>
                    <v-btn
                      v-if="hasPermission('delete_backup_spending', 'delete')"
                      @click="deleteBackup(item.id)"
                      color="red"
                      x-small
                      dark
                      class="ml-2"
                    >
                      Remove
                    </v-btn>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="21" class="text-center">
                    No data displayed
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import ACLMixin from '@/mixins/ACLMixin';
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Swal from 'sweetalert2';
// import moment from 'moment';
import LoginAsMixin from '@/mixins/LoginAsMixin';

export default {
  components: {
    'progress-dialog': ProgressDialog
    // VuePerfectScrollbar
  },
  mixins: [ACLMixin, LoginAsMixin],
  data() {
    return {
      loading: true,
      progressDialogLoading: true,
      items: [],
      descending: true,
      sort: '',
      totalItems: 0,
      page: 1,
      pageCount: 0,
      options: {
        itemsPerPage: 10
      },
      breadcrumbs: [
        {
          text: 'SPENDING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'BACKUP SPENDING',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      scrollSettings: {
        maxScrollbarLength: 260
      },
      baseUrl: process.env.VUE_APP_BASE_URL
    };
  },
  async mounted() {
    await this.getData();
  },
  watch: {
    'options.page'() {
      this.getData();
    },
    'options.itemsPerPage'() {
      this.getData();
    }
  },
  methods: {
    getData() {
      this.progressDialogLoading = true;
      let { page, itemsPerPage } = this.options;
      return this.$store
        .dispatch('spendingDynamic/getBackup', {
          page,
          limit: itemsPerPage
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = Number(data.data.total_data);
            const pageData = data.data.pagination.current_page;
            const itemsPerPageData = data.data.pagination.per_page;
            this.options = { pageData, itemsPerPageData };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    downloadBackup(id) {
      window.open(
        this.baseUrl +
          '/v2/backup/spending/' +
          id +
          '?token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    deleteBackup(id) {
      Swal.fire({
        title: 'Are you sure want to delete this data?',
        text: 'You will not be able to recover this data!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          return this.$store
            .dispatch('spendingDynamic/deleteBackup', id)
            .then(data => {
              this.progressDialogLoading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.getData();
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              this.progressDialogLoading = false;
              this.loading = false;
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            });
        }
      });
    }
  }
};
</script>
<style>
.drawer-menu--scroll {
  max-height: 300px;
  overflow: auto;
}
.drawer-menu--scrollEdit {
  max-height: 450px;
  overflow: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid rgb(151, 151, 151);
}
</style>
